const volotea = {
  volotea_template: "Volotea Template",
  supplierEmail: "Supplier Email",
  email: "Email",
  createTitle: "Create Supplier",
  editTitle: "Edit Supplier",
  supplierId: "Supplier ID",
  registrationNumber: "Registration Number ",
  triggeredBy: "Onboarding to be completed by",
  vendorCompanyName: "Vendor Company Name ",
  customerCompanyName: "Customer Company ",
  paymentTerms: "Payment Terms",
  buyerName: "Buyer Name ",
  buyerManagerName: "Buyer Manager ",
  serviceCountry: "Service Country",
  vendorType: "Vendor Type",
  serviceDescription: "Service Description ",
  amosCode: "AMOS Code",
  officialDocument: "Official Document ",
  companyType: "Company Type",
  taxType: "Tax Type",
  legalName: "Legal Name / Full Name",
  taxAddress: "Address",
  taxNumber: "Tax Number",
  city: "City",
  county: "County",
  postcode: "Postcode",
  country: "Country",
  accountingContactName: "Accounting Contact Name ",
  accountingContactEmail: "Accounting Contact Email ",
  accountingContactPhone: "Accounting Contact Phone ",
  supplierType: "Goods or Services Provider",
  verificationStatus: "Verification Status",
  documentValidityStatus: "Document Validity Status",
  taxResidenceCertificate: "Tax Residence Certificate",
  vendorCompanyId: "Vendor company ID",
  bankName: "Bank Name ",
  iban: "IBAN ",
  swiftCode: "SWIFT/BIC Code ",
  bankAccountCurrency: "Bank Account Currency",
  additionalCertificates: "Additional Certificates",
  bankCertificate: "Bank Certificate ",
  alternateBankDetails: "Alternate bank details",
  helperTexts: {
    officialDocument: "Upload a PDF document to justify onboarding",
    additionalCertificates: "Upload additional certificates in PDF format",
    taxResidenceCertificate: "Upload tax residence certificate in PDF format",
    bankCertificate: "Upload bank certificate in PDF format",
  },
  common: {
    cancel: "Cancel",
    save: "Save",
    update: "Update",
  },
  validation: {
    email: {
      invalid: "Please enter a valid email address",
      required: "Email is required",
    },
    registrationNumber: {
      required: "Registration Number is required",
    },
    vendorCompanyId: {
      required: "Vendor company ID is required",
    },
    vendorCompanyName: {
      required: "Vendor Company Name is required",
    },
    buyerName: {
      required: "Buyer Name is required",
    },
    buyerManagerName: {
      required: "Buyer Manager Name is required",
    },
    customerCompanyName: {
      required: "Customer Company Name is required",
    },
    serviceDescription: {
      required: "Service Description is required",
    },
    vendorCompanyAddress: {
      required: "Vendor Company Address is required",
    },
    contactName: {
      required: "Contact Name is required",
    },
    contactEmail: {
      required: "Contact Email is required",
    },
    contactPhone: {
      required: "Contact Phone is required",
    },
    bankName: {
      required: "Bank Name is required",
    },
    iban: {
      required: "IBAN is required",
    },
    swiftCode: {
      required: "SWIFT Code is required",
    },
    triggeredBy: {
      required: "Triggered By is required",
    },
    paymentTerms: {
      required: "Payment Terms is required",
    },
    vendorType: {
      required: "Vendor Type is required",
    },
    country: {
      required: "Country is required",
    },
    vendorCompanyCountry: {
      required: "Vendor Company Country is required",
    },
    bankAccountCurrency: {
      required: "Bank Account Currency is required",
    },
    supplierType: {
      required: "Supplier Type is required",
    },
    companyType: {
      required: "Company Type is required",
    },
    taxType: {
      required: "Tax Type is required",
    },
    validationStatus: {
      required: "Validation Status is required",
    },
    officialDocument: {
      required: "Official Document is required",
    },
    bankCertificate: {
      required: "Bank Certificate is required",
    },
    certificadosAdicionales: {
      required: "Additional Certificate is required",
    },
    certificadoResidenciaFiscal: {
      required: "Tax Residence Certificate is required",
    },
    documentValidationStatus: {
      required: "Document Validity Status is required",
    },
    certificadoBancario: {
      required: "Bank Certificate is required",
    },
    amosCode: {
      required: "AMOS Code is required",
    },
  },
};

export default volotea;
